// extracted by mini-css-extract-plugin
export var container = "_2b-0";
export var error = "_2b-7";
export var horizontal = "_2b-1";
export var label = "_2b-3";
export var light = "_2b-4";
export var thin = "_2b-6";
export var thinBold = "_2b-5";
export var vertical = "_2b-2";